export default __webpack_public_path__ + "static/media/CURRENT.0f483396.jpg";